import { useContext } from 'react';

import { EnvContext } from '../../contexts/environment.context';
import { SelectorContext } from '../../contexts/selector.context';

import { EnvironmentSelectorIcon, EnvironmentIconContainer, EnvironmentIcon } from './EnvIcon.styles';

const EnvIcon = () => {
  const { selectedEnvironment, setSelectedEnvironment } = useContext(EnvContext);
  const { isSelectorOpen, setSelectorState } = useContext(SelectorContext);

  const toggleEnvSelection = () => {
    selectedEnvironment ? setSelectedEnvironment(null) : setSelectorState(!isSelectorOpen);
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
      console.log('selectedEnvironment = ',selectedEnvironment);
      console.log('isSelectorOpen = ', isSelectorOpen);}

  }
  
  return (
    <EnvironmentIconContainer onClick={toggleEnvSelection}>
      <EnvironmentSelectorIcon />
      <EnvironmentIcon>{selectedEnvironment}</EnvironmentIcon>
    </EnvironmentIconContainer>
  );
};

export default EnvIcon;